import React, { useEffect, useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import filterFactory, {
  textFilter,
  selectFilter,
} from "react-bootstrap-table2-filter";

import { MdEdit, MdOutlineDelete } from "react-icons/md";
import {
  FaWhatsapp,
  FaDownload,
  FaFileDownload,
  FaFileExport,
  FaAddressCard,
  FaCloudUploadAlt,
} from "react-icons/fa";
import { SiMicrosoftexcel } from "react-icons/si";

import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import axios from "axios";

import edMantra from "../../services/edMantra";
import companyUpload from "../../assets/files/ATSCompany.xlsx";
import loadinggif from "../../assets/images/loading.gif";


// =========================================================
// INITIAL STATE
// =========================================================

const initialCompany = {
  companyId: "",

  primaryPOCName: "",
  primaryPOCMobile: "",
  primaryPOCEmail: "",
  primaryPOCDesignation: "",

  secondaryPOCName: "",
  secondaryPOCMobile: "",
  companyStatus: "",
  followupDate: "",

  companyName: "",
  orgCategory: "",
  orgRate: "",
  orgAgree: "",
  createdBy: "",
};


// =========================================================
// COMPONENT
// =========================================================

const ArchiveCompany = () => {
  const { data } = useSelector(
    (state) => state?.currentSession?.userInfo
  );

  // =======================================================
  // COMPANY
  // =======================================================

  const [company, setCompany] =
    useState(initialCompany);

  const [allCompany, setAllCompany] =
    useState([]);

  // =======================================================
  // MODAL
  // =======================================================

  const [showModal, setShowModal] =
    useState(false);

  const [showDocModal, setShowDocModal] =
    useState(false);

  const [isEdit, setIsEdit] =
    useState(false);

  // =======================================================
  // ORGANIZATION
  // =======================================================

  const [selectedCategory, setSelectedCategory] =
    useState("");

  const [orgRate, setOrgRate] =
    useState("");

  const [orgAgreeName, setOrgAgreeName] =
    useState(null);

  // =======================================================
  // RECRUITERS
  // =======================================================

  const [allRecruiters, setAllRecruiters] =
    useState([]);

  // =======================================================
  // LOADING
  // =======================================================

  const [loading, setLoading] =
    useState(true);

  const [isLoading, setIsLoading] =
    useState(false);

  const [refresh, setRefresh] =
    useState(false);

  // =======================================================
  // FILE
  // =======================================================

  const [file, setFile] =
    useState(null);

  const [toggle, setToggle] =
    useState(false);

  const fileInputRef =
    useRef(null);

  // =======================================================
  // DOCUMENT
  // =======================================================

  const [docUrl, setDocUrl] =
    useState("");

  // =======================================================
  // SELECTION
  // =======================================================

  const [selectedRows, setSelectedRows] =
    useState([]);

  const [selectedRowIds, setSelectedRowIds] =
    useState([]);

  // =======================================================
  // PAGINATION
  // =======================================================

  const [page, setPage] =
    useState(1);

  const [sizePerPage, setSizePerPage] =
    useState(50);

  // =======================================================
  // ADD MODAL
  // =======================================================

  const handleShow = () => {
    setCompany(initialCompany);

    setSelectedCategory("");

    setOrgRate("");

    setOrgAgreeName(null);

    setIsEdit(false);

    setShowModal(true);
  };

  // =======================================================
  // CLOSE MODAL
  // =======================================================

  const handleClose = () => {
    setShowModal(false);

    setIsEdit(false);

    setCompany(initialCompany);

    setSelectedCategory("");

    setOrgRate("");

    setOrgAgreeName(null);
  };

  // =======================================================
  // INPUT CHANGE
  // =======================================================

  const handleOnchange = (
    value,
    valueField
  ) => {
    setCompany((prev) => ({
      ...prev,
      [valueField]: value,
    }));

    if (
      valueField ===
      "orgCategory"
    ) {
      setSelectedCategory(value);

      if (
        value ===
        "Agreement Pending"
      ) {
        setCompany((prev) => ({
          ...prev,
          orgCategory: value,
          orgRate: "",
        }));

        setOrgRate("");
      }
    }

    if (
      valueField ===
      "orgRate"
    ) {
      setOrgRate(value);
    }
  };

  // =======================================================
  // GET COMPANY DATA
  // =======================================================

  const getAllCompany = async () => {
    try {
      setLoading(true);

      const response =
        await edMantra.getdeadCompany();

      console.log(
        "Company API Response:",
        response
      );

      const companies =
        Array.isArray(
          response?.data?.data
        )
          ? response.data.data
          : [];

      setAllCompany(
        companies
      );

    } catch (error) {
      console.error(
        "Error fetching companies:",
        error
      );

      setAllCompany([]);

      toast.error(
        "Unable to load company data."
      );
    } finally {
      setLoading(false);
    }
  };

  // =======================================================
  // RECRUITERS
  // =======================================================

  const getAllRecruiters =
    async () => {
      try {
        const response =
          await edMantra.getAllRecruiters();

        if (
          Array.isArray(
            response?.data?.data
          )
        ) {
          setAllRecruiters(
            response.data.data
          );
        } else {
          setAllRecruiters([]);
        }
      } catch (error) {
        console.error(
          "Error fetching recruiters:",
          error
        );

        setAllRecruiters([]);
      }
    };

  // =======================================================
  // USE EFFECT
  // =======================================================

  useEffect(() => {
    getAllCompany();
  }, [refresh]);

  useEffect(() => {
    getAllRecruiters();
  }, [refresh]);

  // =======================================================
  // PAGINATION
  // =======================================================

  const pagination =
    paginationFactory({
      page,
      sizePerPage,
      totalSize:
        allCompany.length,

      showTotal: true,

      sizePerPageList: [
        {
          text: "50",
          value: 50,
        },
        {
          text: "100",
          value: 100,
        },
        {
          text: "500",
          value: 500,
        },
        {
          text: "1000",
          value: 1000,
        },
      ],

      onPageChange: (
        newPage
      ) => {
        setPage(newPage);
      },

      onSizePerPageChange: (
        newSize,
        newPage
      ) => {
        setSizePerPage(
          newSize
        );

        setPage(
          newPage
        );
      },
    });

  // =======================================================
  // FILE SELECT
  // =======================================================

  const handleButtonClick =
    () => {
      fileInputRef?.current?.click();
    };

  const handleFileChange =
    (e) => {
      const selectedFile =
        e.target.files?.[0];

      if (!selectedFile) {
        return;
      }

      setFile(
        selectedFile
      );

      setToggle(true);
    };

  // =======================================================
  // UPLOAD EXCEL
  // =======================================================

  const handleUpload =
    async () => {
      if (!file) {
        toast.error(
          "Please select an Excel file."
        );

        return;
      }

      const formData =
        new FormData();

      formData.append(
        "companyfile",
        file
      );

      formData.append(
        "empId",
        data?.empId || ""
      );

      try {
        setIsLoading(true);

        const result =
          await edMantra.uploadCompany(
            formData
          );

        if (
          result?.data
            ?.errorCode ===
          0
        ) {
          toast.success(
            result?.data
              ?.message ||
              "File uploaded successfully."
          );

          setFile(null);

          setToggle(false);

          setRefresh(
            (prev) =>
              !prev
          );

          if (
            fileInputRef.current
          ) {
            fileInputRef.current.value =
              "";
          }
        } else {
          toast.error(
            result?.data
              ?.message ||
              "Unable to upload company file."
          );
        }
      } catch (error) {
        console.error(
          "Upload error:",
          error
        );

        toast.error(
          error?.response
            ?.data?.message ||
            "Unable to upload company file."
        );
      } finally {
        setIsLoading(false);
      }
    };

  // =======================================================
  // ADD COMPANY
  // =======================================================

  const handleSubmit =
    async () => {
      if (
        !company.companyName?.trim()
      ) {
        toast.error(
          "Please enter company name."
        );

        return;
      }

      if (
        !company.primaryPOCName?.trim()
      ) {
        toast.error(
          "Please enter primary POC name."
        );

        return;
      }

      if (
        !company.primaryPOCMobile?.trim()
      ) {
        toast.error(
          "Please enter primary POC mobile number."
        );

        return;
      }

      const formData =
        new FormData();

      if (orgAgreeName) {
        formData.append(
          "orgAgreeDoc",
          orgAgreeName
        );
      }

      formData.append(
        "primaryPOCName",
        company.primaryPOCName ||
          ""
      );

      formData.append(
        "primaryPOCMobile",
        company.primaryPOCMobile ||
          ""
      );

      formData.append(
        "primaryPOCEmail",
        company.primaryPOCEmail ||
          ""
      );

      formData.append(
        "primaryPOCDesignation",
        company.primaryPOCDesignation ||
          ""
      );

      formData.append(
        "secondaryPOCName",
        company.secondaryPOCName ||
          ""
      );

      formData.append(
        "secondaryPOCMobile",
        company.secondaryPOCMobile ||
          ""
      );

      formData.append(
        "companyStatus",
        company.companyStatus ||
          ""
      );

      formData.append(
        "followupDate",
        company.followupDate ||
          ""
      );

      formData.append(
        "companyName",
        company.companyName ||
          ""
      );

      formData.append(
        "orgCategory",
        company.orgCategory ||
          ""
      );

      formData.append(
        "orgRate",
        company.orgRate ||
          ""
      );

      formData.append(
        "createdBy",
        data?.empId || ""
      );

      try {
        setIsLoading(true);

        const response =
          await axios.post(
            "https://mantraserp.com/api/addCompany",
            formData
          );

        const result =
          response?.data;

        if (
          result?.errorCode ===
          0
        ) {
          toast.success(
            result?.message ||
              "Company added successfully."
          );

          handleClose();

          setRefresh(
            (prev) =>
              !prev
          );
        } else {
          toast.error(
            result?.message ||
              "Unable to add company."
          );
        }
      } catch (error) {
        console.error(
          "Add company error:",
          error
        );

        toast.error(
          error?.response
            ?.data?.message ||
            "Unable to add company."
        );
      } finally {
        setIsLoading(false);
      }
    };

  // =======================================================
  // UPDATE COMPANY
  // =======================================================

  const handleUpdateCompany =
    async () => {
      if (
        !company?.companyId
      ) {
        toast.error(
          "Company ID is missing."
        );

        return;
      }

      if (
        !company.companyName?.trim()
      ) {
        toast.error(
          "Please enter company name."
        );

        return;
      }

      const formData =
        new FormData();

      formData.append(
        "companyId",
        company.companyId
      );

      if (orgAgreeName) {
        formData.append(
          "orgAgreeDoc",
          orgAgreeName
        );
      }

      formData.append(
        "primaryPOCName",
        company.primaryPOCName ||
          ""
      );

      formData.append(
        "primaryPOCMobile",
        company.primaryPOCMobile ||
          ""
      );

      formData.append(
        "primaryPOCEmail",
        company.primaryPOCEmail ||
          ""
      );

      formData.append(
        "primaryPOCDesignation",
        company.primaryPOCDesignation ||
          ""
      );

      formData.append(
        "secondaryPOCName",
        company.secondaryPOCName ||
          ""
      );

      formData.append(
        "secondaryPOCMobile",
        company.secondaryPOCMobile ||
          ""
      );

      formData.append(
        "companyStatus",
        company.companyStatus ||
          ""
      );

      formData.append(
        "followupDate",
        company.followupDate ||
          ""
      );

      formData.append(
        "companyName",
        company.companyName ||
          ""
      );

      formData.append(
        "orgCategory",
        company.orgCategory ||
          ""
      );

      formData.append(
        "orgRate",
        company.orgRate ||
          ""
      );

      formData.append(
        "createdBy",
        data?.empId ||
          company.createdBy ||
          ""
      );

      try {
        setIsLoading(true);

        const response =
          await axios.post(
            "https://mantraserp.com/api/updateCompanyById",
            formData
          );

        const result =
          response?.data;

        if (
          result?.errorCode ===
          0
        ) {
          toast.success(
            result?.message ||
              "Company updated successfully."
          );

          handleClose();

          setRefresh(
            (prev) =>
              !prev
          );
        } else {
          toast.error(
            result?.message ||
              "Unable to update company."
          );
        }
      } catch (error) {
        console.error(
          "Update company error:",
          error
        );

        toast.error(
          error?.response
            ?.data?.message ||
            "Failed to update company."
        );
      } finally {
        setIsLoading(false);
      }
    };

  // =======================================================
  // EDIT
  // =======================================================

  const handleEdit = (
    row
  ) => {
    setCompany({
      ...initialCompany,
      ...row,
    });

    setSelectedCategory(
      row?.orgCategory || ""
    );

    setOrgRate(
      row?.orgRate || ""
    );

    setOrgAgreeName(null);

    setIsEdit(true);

    setShowModal(true);
  };

  // =======================================================
  // DELETE
  // =======================================================

  const handleDelete =
    async (
      companyId
    ) => {
      if (!companyId) {
        toast.error(
          "Company ID is missing."
        );

        return;
      }

      const confirmed =
        window.confirm(
          "Are you sure you want to delete this company?"
        );

      if (!confirmed) {
        return;
      }

      try {
        const result =
          await edMantra.deleteCompanyById(
            {
              companyId,
            }
          );

        if (
          result?.data
            ?.errorCode ===
          0
        ) {
          toast.success(
            result?.data
              ?.message ||
              "Company deleted successfully."
          );

          setRefresh(
            (prev) =>
              !prev
          );
        } else {
          toast.error(
            result?.data
              ?.message ||
              "Unable to delete company."
          );
        }
      } catch (error) {
        console.error(
          "Delete error:",
          error
        );

        toast.error(
          error?.response
            ?.data?.message ||
            "Unable to delete company."
        );
      }
    };

  // =======================================================
  // WHATSAPP
  // =======================================================

  const openWhatsApp =
    (
      mobile
    ) => {
      if (!mobile) {
        toast.error(
          "Mobile number is not available."
        );

        return;
      }

      let phone =
        String(mobile).replace(
          /\D/g,
          ""
        );

      if (
        phone.length ===
        10
      ) {
        phone =
          `91${phone}`;
      }

      window.open(
        `https://wa.me/${phone}`,
        "_blank",
        "noopener,noreferrer"
      );
    };

  // =======================================================
  // DOWNLOAD AGREEMENT
  // =======================================================

  const handleAadharDownlaod =
    async (
      fileName
    ) => {
      try {
        if (!fileName) {
          toast.error(
            "No agreement document available."
          );

          return;
        }

        const response =
          await axios.post(
            "https://mantraserp.com/api/orgdownload",
            {
              filename:
                encodeURIComponent(
                  fileName
                ),
            },
            {
              responseType:
                "blob",
            }
          );

        const blob =
          new Blob([
            response.data,
          ]);

        const url =
          window.URL.createObjectURL(
            blob
          );

        const link =
          document.createElement(
            "a"
          );

        link.href = url;

        link.setAttribute(
          "download",
          fileName
        );

        document.body.appendChild(
          link
        );

        link.click();

        link.remove();

        window.URL.revokeObjectURL(
          url
        );
      } catch (error) {
        console.error(
          "Download error:",
          error
        );

        toast.error(
          "Unable to download agreement."
        );
      }
    };

  // =======================================================
  // VIEW DOCUMENT
  // =======================================================

  const handleViewDoc =
    (docName) => {
      if (!docName) {
        toast.error(
          "No agreement document available."
        );

        return;
      }

      const url =
        `${window.location.origin}/orguploads/${docName}`;

      setDocUrl(url);

      setShowDocModal(true);
    };

  const handleCloseDoc =
    () => {
      setShowDocModal(false);

      setDocUrl("");
    };

  // =======================================================
  // BULK DELETE
  // =======================================================

  const handleBulkDelete =
    async () => {
      if (
        selectedRows.length ===
        0
      ) {
        toast.warning(
          "Please select at least one company."
        );

        return;
      }

      const confirmed =
        window.confirm(
          `Are you sure you want to delete ${selectedRows.length} selected company(s)?`
        );

      if (!confirmed) {
        return;
      }

      try {
        const result =
          await edMantra.deleteBulkCompany(
            {
              company:
                selectedRows,
            }
          );

        if (
          result?.data
            ?.errorCode ===
          0
        ) {
          toast.success(
            result?.data
              ?.message ||
              "Companies deleted successfully."
          );

          setSelectedRows([]);

          setSelectedRowIds([]);

          setRefresh(
            (prev) =>
              !prev
          );
        } else {
          toast.error(
            result?.data
              ?.message ||
              "Unable to delete companies."
          );
        }
      } catch (error) {
        console.error(
          "Bulk delete error:",
          error
        );

        toast.error(
          error?.response
            ?.data?.message ||
            "Unable to delete companies."
        );
      }
    };

  // =======================================================
  // BULK recover
  // =======================================================

  const handleBulkRecover = async () => {
  try {
    //const response = await axios.put("http://localhost:5000/api/recoverbulkCompany",
        const response = await axios.put("https://mantraserp.com/api/recoverbulkCompany",
      {
        company: selectedRows,
      }
    );

    console.log("Recover Response:", response.data);

    if (response.data.errorCode === 0) {
      // Refresh Archive Company list
      getAllCompany();
    }

  } catch (error) {
    console.error("Error recovering companies:", error);
  }
};

  // =======================================================
  // SELECT ROW
  // =======================================================

  const handleRowSelect =
    (
      row,
      isSelected
    ) => {
      if (isSelected) {
        setSelectedRows(
          (prev) => {
            const exists =
              prev.some(
                (item) =>
                  item.companyId ===
                  row.companyId
              );

            return exists
              ? prev
              : [
                  ...prev,
                  row,
                ];
          }
        );

        setSelectedRowIds(
          (prev) =>
            prev.includes(
              row.companyId
            )
              ? prev
              : [
                  ...prev,
                  row.companyId,
                ]
        );
      } else {
        setSelectedRows(
          (prev) =>
            prev.filter(
              (item) =>
                item.companyId !==
                row.companyId
            )
        );

        setSelectedRowIds(
          (prev) =>
            prev.filter(
              (id) =>
                id !==
                row.companyId
            )
        );
      }
    };

  // =======================================================
  // SELECT ALL
  // =======================================================

  const handleRowSelectAll =
    (
      isSelected,
      rows
    ) => {
      if (isSelected) {
        setSelectedRows(
          rows
        );

        setSelectedRowIds(
          rows.map(
            (row) =>
              row.companyId
          )
        );
      } else {
        setSelectedRows([]);

        setSelectedRowIds([]);
      }
    };

  // =======================================================
  // EXPORT CSV
  // =======================================================

  const exportCSV = () => {
    if (
      !allCompany ||
      allCompany.length ===
        0
    ) {
      toast.warning(
        "No company records available for export."
      );

      return;
    }

    const headers = [
      "Company Name",
      "Primary POC Name",
      "Primary POC Number",
      "Primary POC Email",
      "Primary POC Designation",
      "Secondary POC Name",
      "Secondary POC Number",
      "Secondary POC Email",
      "Secondary POC Designation",
      "Org Category",
      "Org Fees",
      "Org Agreement",
      "Created By",
    ];

    const rows =
      allCompany.map(
        (row) => {
          const recruiter =
            allRecruiters.find(
              (emp) =>
                String(
                  emp.empId
                ) ===
                String(
                  row?.createdBy
                )
            );

          const recruiterName =
            recruiter
              ? `${recruiter.fname || ""} ${
                  recruiter.lname ||
                  ""
                }`.trim()
              : row?.createdBy ||
                "";

          return [
            row?.companyName ||
              "",
            row?.primaryPOCName ||
              "",
            row?.primaryPOCMobile ||
              "",
            row?.primaryPOCEmail ||
              "",
            row?.primaryPOCDesignation ||
              "",
            row?.secondaryPOCName ||
              "",
            row?.secondaryPOCMobile ||
              "",
            row?.companyStatus ||
              "",
            row?.followupDate ||
              "",
            row?.orgCategory ||
              "",
            row?.orgRate ||
              "",
            row?.orgAgree ||
              "",
            recruiterName,
          ];
        }
      );

    const escapeCSV = (
      value
    ) => {
      const stringValue =
        String(
          value ?? ""
        );

      return `"${stringValue.replace(
        /"/g,
        '""'
      )}"`;
    };

    const csvContent = [
      headers
        .map(
          escapeCSV
        )
        .join(","),

      ...rows.map(
        (row) =>
          row
            .map(
              escapeCSV
            )
            .join(",")
      ),
    ].join("\n");

    const blob =
      new Blob(
        [
          "\uFEFF" +
            csvContent,
        ],
        {
          type:
            "text/csv;charset=utf-8;",
        }
      );

    const url =
      URL.createObjectURL(
        blob
      );

    const link =
      document.createElement(
        "a"
      );

    link.href = url;

    link.download =
      "MantrasERP_Archived_Companies_Report.csv";

    document.body.appendChild(
      link
    );

    link.click();

    link.remove();

    URL.revokeObjectURL(
      url
    );
  };

  // =======================================================
  // TABLE COLUMNS
  // =======================================================

  const columns = [
    {
      dataField:
        "companyName",
      text: "Company Name",
      sort: true,
      filter:
        textFilter(),
      headerStyle: {
        minWidth:
          "180px",
      },
    },

    {
      dataField:
        "primaryPOCName",
      text: "Primary POC",
      sort: true,
      filter:
        textFilter(),
      headerStyle: {
        minWidth:
          "150px",
      },
    },

    {
      dataField:
        "primaryPOCMobile",
      text: "Primary POC Number",
      sort: true,
      filter:
        textFilter(),
      headerStyle: {
        minWidth:
          "160px",
      },
    },

    {
      dataField:
        "primaryPOCEmail",
      text: "Primary POC Email",
      filter:
        textFilter(),
      headerStyle: {
        minWidth:
          "220px",
      },
    },

    {
      dataField:
        "primaryPOCDesignation",
      text: "Primary Designation",
      sort: true,
      filter:
        textFilter(),
      headerStyle: {
        minWidth:
          "180px",
      },
    },

    {
      dataField:
        "secondaryPOCName",
      text: "Secondary POC",
      sort: true,
      filter:
        textFilter(),
      headerStyle: {
        minWidth:
          "160px",
      },
    },

    {
      dataField:
        "secondaryPOCMobile",
      text: "Secondary POC Number",
      sort: true,
      filter:
        textFilter(),
      headerStyle: {
        minWidth:
          "170px",
      },
    },

    {
      dataField:
        "companyStatus",
      text: "Secondary POC Email",
      filter:
        textFilter(),
      headerStyle: {
        minWidth:
          "220px",
      },
    },

    {
      dataField:
        "followupDate",
      text: "Secondary Designation",
      sort: true,
      filter:
        textFilter(),
      headerStyle: {
        minWidth:
          "180px",
      },
    },

    {
      dataField:
        "orgCategory",
      text: "Org. Category",
      sort: true,
      filter:
        textFilter(),
      headerStyle: {
        minWidth:
          "140px",
      },
    },

    {
      dataField:
        "orgRate",
      text: "Org. Fees",
      sort: true,
      filter:
        textFilter(),
      headerStyle: {
        minWidth:
          "120px",
      },
    },

    {
      dataField:
        "orgAgree",
      text: "Org. Agreement",

      formatter: (
        cell,
        row
      ) => {
        if (
          !row?.orgAgree
        ) {
          return "N/A";
        }

        return (
          <div className="d-flex align-items-center gap-2">
            <span
              title={
                row.orgAgree
              }
              style={{
                maxWidth:
                  "120px",
                overflow:
                  "hidden",
                textOverflow:
                  "ellipsis",
                whiteSpace:
                  "nowrap",
              }}
            >
              {
                row.orgAgree
              }
            </span>

            <FaDownload
              size={
                16
              }
              style={{
                cursor:
                  "pointer",
              }}
              onClick={() =>
                handleAadharDownlaod(
                  row.orgAgree
                )
              }
            />
          </div>
        );
      },

      headerStyle: {
        minWidth:
          "190px",
      },
    },

    {
      dataField:
        "createdBy",

      text: "Recruitment Manager",

      sort: true,

      filter:
        selectFilter({
          options:
            allRecruiters.length >
            0
              ? allRecruiters.map(
                  (emp) => ({
                    value:
                      emp.empId,
                    label:
                      `${emp.fname || ""} ${
                        emp.lname ||
                        ""
                      }`.trim(),
                  })
                )
              : [],

          placeholder:
            "Select or Search by Name",
        }),

      formatter: (
        cell,
        row
      ) => {
        const recruiter =
          allRecruiters.find(
            (emp) =>
              String(
                emp.empId
              ) ===
              String(
                row?.createdBy
              )
          );

        if (
          !recruiter
        ) {
          return (
            row?.createdBy ||
            "Data not available"
          );
        }

        return `${recruiter.fname || ""} ${
          recruiter.lname ||
          ""
        }`.trim();
      },

      headerStyle: {
        minWidth:
          "190px",
      },
    },

    {
      dataField:
        "action",

      text: "Action",

      formatter: (
        cell,
        row
      ) => (
        <div className="d-flex align-items-center gap-2">

          {row?.primaryPOCMobile && (
            <FaWhatsapp
              size={
                20
              }
              color="limegreen"
              style={{
                cursor:
                  "pointer",
              }}
              onClick={() =>
                openWhatsApp(
                  row.primaryPOCMobile
                )
              }
            />
          )}

          <MdEdit
            size={
              23
            }
            color="black"
            style={{
              cursor:
                "pointer",
            }}
            onClick={() =>
              handleEdit(
                row
              )
            }
          />

          {(data?.role
            ?.roleName ===
            "SuperAdmin" ||
            data?.role
              ?.roleName ===
              "AdminEM") && (
            <MdOutlineDelete
              size={
                23
              }
              color="red"
              style={{
                cursor:
                  "pointer",
              }}
              onClick={() =>
                handleDelete(
                  row.companyId
                )
              }
            />
          )}
        </div>
      ),

      headerStyle: {
        minWidth:
          "110px",
      },
    },
  ];

  // =======================================================
  // RENDER
  // =======================================================

  return (
    <>
      {/* ================================================= */}
      {/* HIDDEN FILE */}
      {/* ================================================= */}

      <input
        type="file"
        ref={
          fileInputRef
        }
        style={{
          display:
            "none",
        }}
        accept=".xlsx,.xls"
        onChange={
          handleFileChange
        }
      />

      <div className="container-fluid">
        <div className="row">

          {/* ============================================= */}
          {/* TITLE */}
          {/* ============================================= */}

          <div className="col-md-4 card border-0">
            <p className="fs-3 fw-normal typed-text">
              Archive Company
            </p>
          </div>

          {/* ============================================= */}
          {/* BUTTONS */}
          {/* ============================================= */}

          <div className="card col-md-4 col-sm-12 border-0">
            <div className="d-flex flex-wrap align-items-center">

              {toggle ? (
                <button
                  type="button"
                  className="btn btn-warning btn-sm p-2 m-1"
                  onClick={
                    handleUpload
                  }
                  disabled={
                    isLoading
                  }
                >
                  <FaCloudUploadAlt
                    color="black"
                    size={
                      20
                    }
                  />{" "}
                  {isLoading
                    ? "Uploading..."
                    : "Upload"}
                </button>
              ) : (
                <>
                  <button
                    type="button"
                    className="btn btn-warning btn-sm p-2 m-1"
                    onClick={
                      handleButtonClick
                    }
                  >
                    <FaFileDownload
                      color="black"
                      size={
                        20
                      }
                    />{" "}
                    Import
                  </button>

                  <a
                    href={
                      companyUpload
                    }
                    download
                    className="btn btn-warning btn-sm m-1"
                  >
                    <FaFileExport
                      color="black"
                      size={
                        20
                      }
                    />{" "}
                    Sample File
                  </a>

                  <button
                    type="button"
                    className="btn btn-warning btn-sm m-1"
                    onClick={
                      handleShow
                    }
                  >
                    <FaAddressCard
                      color="black"
                      size={
                        20
                      }
                    />{" "}
                    Add Company
                  </button>
                </>
              )}
            </div>
          </div>

          {/* ============================================= */}
          {/* BULK ACTIONS */}
          {/* ============================================= */}

          <div className="card col-md-4 col-sm-12 border-0 mt-2">

            {(data?.role
              ?.roleName ===
              "SuperAdmin" ||
              data?.role
                ?.roleName ===
                "AdminEM") && (
              <select
                className="form-select border-1 mb-2"
                value=""
                onChange={(
                  e
                ) => {
                  if (
                    e.target
                      .value ===
                    "Delete Company"
                  ) {
                    handleBulkDelete();
                  }
                  else if (
                    e.target
                      .value ===
                    "Live Company"
                  ) {
                    handleBulkRecover(
                      data?.empId ||
                        ""
                    );
                  }
                }}
              >
                <option value="">
                  Select Action
                </option>

                <option value="Delete Company">
                  Delete Selected  Companies
                </option>
                 <option value="Live Company">
                  Recover Selected  Companies
                </option>
              </select>
            )}

          
          </div>

          {/* ============================================= */}
          {/* TABLE */}
          {/* ============================================= */}

          <div className="card col-md-12 border-0">

            {loading ? (
              <div className="d-flex justify-content-center align-items-center p-5">
                <img
                  src={
                    loadinggif
                  }
                  alt="Loading"
                />
              </div>
            ) : (
              <>
                {/* ====================================== */}
                {/* EXPORT */}
                {/* ====================================== */}

                {(data?.role
                  ?.roleName ===
                  "SuperAdmin" ||
                  data?.role
                    ?.roleName ===
                    "AdminEM") && (
                  <button
                    type="button"
                    className="btn btn-success btn-sm mb-2 float-end"
                    onClick={
                      exportCSV
                    }
                  >
                    <SiMicrosoftexcel />{" "}
                    Export Record
                  </button>
                )}

                {/* ====================================== */}
                {/* TABLE */}
                {/* ====================================== */}

                <div className="table-responsive cus-table">
                  <BootstrapTable
                    keyField="companyId"
                    data={
                      allCompany
                    }
                    columns={
                      columns
                    }
                    bootstrap4
                    striped
                    hover
                    condensed
                    filter={
                      filterFactory()
                    }
                    pagination={
                      pagination
                    }
                    filterPosition="top"
                    selectRow={{
                      mode: "checkbox",
                      clickToSelect:
                        true,
                      selected:
                        selectedRowIds,
                      onSelect:
                        handleRowSelect,
                      onSelectAll:
                        handleRowSelectAll,
                    }}
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {/* ================================================= */}
      {/* DOCUMENT MODAL */}
      {/* ================================================= */}

      <Modal
        show={
          showDocModal
        }
        onHide={
          handleCloseDoc
        }
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            View Document
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {docUrl ? (
            docUrl
              .toLowerCase()
              .endsWith(
                ".pdf"
              ) ? (
              <iframe
                src={
                  docUrl
                }
                title="Agreement Document"
                width="100%"
                height="500px"
                style={{
                  border:
                    "none",
                }}
              />
            ) : (
              <img
                src={
                  docUrl
                }
                alt="Document Preview"
                style={{
                  width:
                    "100%",
                }}
              />
            )
          ) : (
            <p>
              Document not
              available.
            </p>
          )}
        </Modal.Body>
      </Modal>

      {/* ================================================= */}
      {/* ADD / EDIT COMPANY */}
      {/* ================================================= */}

      <Modal
        show={
          showModal
        }
        onHide={
          handleClose
        }
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {isEdit
              ? "Edit Company"
              : "Add Company"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body
          style={{
            maxHeight:
              "70vh",
            overflowY:
              "auto",
          }}
        >
          {/* ============================================ */}
          {/* ORGANIZATION */}
          {/* ============================================ */}

          <h6 className="custom-h6">
            Organization
            Information
          </h6>

          <div className="row">

            <div className="col-md-6">
              <p className="mb-0 fs-6">
                Company Name
              </p>

              <input
                placeholder="Company Name"
                className="form-control py-0"
                type="text"
                value={
                  company.companyName
                }
                onChange={(
                  e
                ) =>
                  handleOnchange(
                    e.target
                      .value,
                    "companyName"
                  )
                }
              />
            </div>

            <div className="col-md-6">
              <p className="mb-0 fs-6">
                Category
              </p>

              <select
                className="form-control"
                value={
                  company.orgCategory
                }
                onChange={(
                  e
                ) =>
                  handleOnchange(
                    e.target
                      .value,
                    "orgCategory"
                  )
                }
              >
                <option value="">
                  Select Category
                </option>

                <option value="Silver">
                  Silver
                </option>

                <option value="Gold">
                  Gold
                </option>

                <option value="Platinum">
                  Platinum
                </option>

                <option value="Agreement Pending">
                  Agreement Pending
                </option>
              </select>
            </div>

            {/* ========================================== */}
            {/* RATE */}
            {/* ========================================== */}

            {[
              "Silver",
              "Gold",
              "Platinum",
            ].includes(
              selectedCategory
            ) && (
              <div className="col-md-12 mt-3">
                <label>
                  Agreed Rate
                </label>

                <input
                  type="text"
                  className="form-control"
                  placeholder="Agreed Rate"
                  value={
                    company.orgRate
                  }
                  onChange={(
                    e
                  ) =>
                    handleOnchange(
                      e.target
                        .value,
                      "orgRate"
                    )
                  }
                />
              </div>
            )}

            {/* ========================================== */}
            {/* AGREEMENT */}
            {/* ========================================== */}

            {[
              "Silver",
              "Gold",
              "Platinum",
            ].includes(
              selectedCategory
            ) && (
              <div className="col-md-12 mt-3">

                <p className="mb-0 fs-6">
                  Org. Agreement
                </p>

                {isEdit &&
                  company.orgAgree &&
                  !orgAgreeName && (
                    <div className="mb-2">

                      <small className="text-muted">
                        Existing File:{" "}
                        <strong>
                          {
                            company.orgAgree
                          }
                        </strong>
                      </small>

                      <button
                        type="button"
                        className="btn btn-sm btn-outline-success ms-2"
                        onClick={() =>
                          handleAadharDownlaod(
                            company.orgAgree
                          )
                        }
                      >
                        <FaDownload />
                      </button>
                    </div>
                  )}

                <input
                  className="form-control"
                  type="file"
                  accept=".pdf,.doc,.docx"
                  name="orgAgreeDoc"
                  onChange={(
                    e
                  ) =>
                    setOrgAgreeName(
                      e.target
                        .files?.[0] ||
                        null
                    )
                  }
                />
              </div>
            )}
          </div>

          {/* ============================================ */}
          {/* PRIMARY POC */}
          {/* ============================================ */}

          <h6 className="custom-h6 mt-5">
            Primary Point
            of Contact
          </h6>

          <div className="row">

            <div className="col-md-4">
              <p className="mb-0 fs-6">
                Name
              </p>

              <input
                placeholder="Name"
                className="form-control py-0"
                type="text"
                value={
                  company.primaryPOCName
                }
                onChange={(
                  e
                ) =>
                  handleOnchange(
                    e.target
                      .value,
                    "primaryPOCName"
                  )
                }
              />
            </div>

            <div className="col-md-4">
              <p className="mb-0 fs-6">
                Contact No
              </p>

              <input
                placeholder="Contact Number"
                className="form-control py-0"
                type="tel"
                maxLength="10"
                value={
                  company.primaryPOCMobile
                }
                onChange={(
                  e
                ) => {
                  const value =
                    e.target
                      .value;

                  if (
                    /^\d{0,10}$/.test(
                      value
                    )
                  ) {
                    handleOnchange(
                      value,
                      "primaryPOCMobile"
                    );
                  }
                }}
              />
            </div>

            <div className="col-md-4">
              <p className="mb-0 fs-6">
                Email Address
              </p>

              <input
                placeholder="Enter Email Address"
                className="form-control py-0"
                type="email"
                value={
                  company.primaryPOCEmail
                }
                onChange={(
                  e
                ) =>
                  handleOnchange(
                    e.target
                      .value,
                    "primaryPOCEmail"
                  )
                }
              />
            </div>

            <div className="col-md-12 mt-3">
              <p className="mb-0 fs-6">
                Designation
              </p>

              <input
                placeholder="Designation"
                className="form-control py-0"
                type="text"
                value={
                  company.primaryPOCDesignation
                }
                onChange={(
                  e
                ) =>
                  handleOnchange(
                    e.target
                      .value,
                    "primaryPOCDesignation"
                  )
                }
              />
            </div>
          </div>

          {/* ============================================ */}
          {/* SECONDARY POC */}
          {/* ============================================ */}

          <h6 className="custom-h6 mt-5">
            Secondary Point
            of Contact
          </h6>

          <div className="row">

            <div className="col-md-4">
              <p className="mb-0 fs-6">
                Name
              </p>

              <input
                placeholder="Name"
                className="form-control py-0"
                type="text"
                value={
                  company.secondaryPOCName
                }
                onChange={(
                  e
                ) =>
                  handleOnchange(
                    e.target
                      .value,
                    "secondaryPOCName"
                  )
                }
              />
            </div>

            <div className="col-md-4">
              <p className="mb-0 fs-6">
                Contact No
              </p>

              <input
                placeholder="Contact Number"
                className="form-control py-0"
                type="tel"
                maxLength="10"
                value={
                  company.secondaryPOCMobile
                }
                onChange={(
                  e
                ) => {
                  const value =
                    e.target
                      .value;

                  if (
                    /^\d{0,10}$/.test(
                      value
                    )
                  ) {
                    handleOnchange(
                      value,
                      "secondaryPOCMobile"
                    );
                  }
                }}
              />
            </div>

            <div className="col-md-4">
              <p className="mb-0 fs-6">
                Email Address
              </p>

              <input
                placeholder="Enter Email Address"
                className="form-control py-0"
                type="email"
                value={
                  company.companyStatus
                }
                onChange={(
                  e
                ) =>
                  handleOnchange(
                    e.target
                      .value,
                    "companyStatus"
                  )
                }
              />
            </div>

            <div className="col-md-12 mt-3">
              <p className="mb-0 fs-6">
                Designation
              </p>

              <input
                placeholder="Designation"
                className="form-control py-0"
                type="text"
                value={
                  company.followupDate
                }
                onChange={(
                  e
                ) =>
                  handleOnchange(
                    e.target
                      .value,
                    "followupDate"
                  )
                }
              />
            </div>

          </div>
        </Modal.Body>

        {/* ============================================== */}
        {/* MODAL FOOTER */}
        {/* ============================================== */}

        <Modal.Footer>

          <Button
            variant="secondary"
            onClick={
              handleClose
            }
            size="sm"
            disabled={
              isLoading
            }
          >
            Close
          </Button>

          {isEdit ? (
            <Button
              variant="primary"
              onClick={
                handleUpdateCompany
              }
              size="sm"
              disabled={
                isLoading
              }
            >
              {isLoading
                ? "Updating..."
                : "Update Company"}
            </Button>
          ) : (
            <Button
              variant="primary"
              onClick={
                handleSubmit
              }
              size="sm"
              disabled={
                isLoading
              }
            >
              {isLoading
                ? "Saving..."
                : "Add Company"}
            </Button>
          )}

        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ArchiveCompany;